import "../Amc/ApprovedTask.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import active from "../Components/Assets/Admin-Assets/green-active.png";
import targetactive from "../Components/Assets/Admin-Assets/red-active.png";
import x from "../Components/Assets/Management/x-task.png";
import fb from "../Components/Assets/Management/fb-task.png";
import li from "../Components/Assets/Management/linkedin-task.png";
import insta from "../Components/Assets/Management/instagram-task.png";
import { formatFeedbackText } from "../utils/feedbackFormatter";

export function TotalTask() {
  const [approvedCompanies, setApprovedCompanies] = useState([]);
  const [selectedApprovedTask, setSelectedApprovedTask] = useState(null);
  const [showSelectedTaskWindow, setShowSelectedTaskWindow] = useState(false);
  const [showApprovedTaskGrid, setShowApprovedTaskGrid] = useState(true);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showTaskpreview, setShowTaskpreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedRolledBackTask, setSelectedRolledBackTask] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();

  const fetchCompanyAllDetails = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/admin/login");
      return;
    }
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/all-companies",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        console.log("Successfull fetch Total Task Section-3");
        const approvedCompanies = response.data.filter(
          (company) => company.tasks.length > 0
        );

        if (approvedCompanies.length > 0) {
          setApprovedCompanies(approvedCompanies);
        } else {
          console.log("No Task Found");
        }
      } else {
        toast.error("Failed to fetch company profile");
      }
    } catch (error) {
      console.error("Error fetching company profile:", error);
      toast.error("An error occurred while fetching company details.");
      navigate("/admin/login");
    }
  };

  useEffect(() => {
    fetchCompanyAllDetails();
  }, []);

  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return {
          backgroundColor: " #5eb35eb7",
        };
      case "Pending":
        return {
          backgroundColor: " #ff9100",
        };
      case "Roll Back":
        return {
          backgroundColor: " #f54100",
        };
      case "Posted":
        return {
          backgroundColor: "rgb(128, 0, 255)",
        };
      default:
        return {};
    }
  };
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // yyyy-mm-dd format
  };
  function getDaysDifference(dateString) {
    if (!dateString) return "-";
    const today = new Date();
    const target = new Date(dateString);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    return diffDays > 0 ? `${diffDays} Days` : `${Math.abs(diffDays)} Days Ago`;
  }

  return (
    <>
      <div className="admin-approved-task-container">
        {showApprovedTaskGrid && (
          <div className="approved-task-row-container">
            {approvedCompanies.map((company) => {
              const orderedTasks = [...company.tasks].sort((a, b) => {
                const statusOrder = {
                  "Roll Back": 0,
                  Pending: 1,
                  Approved: 2,
                };
                return (
                  (statusOrder[a.currentStatus] ?? 3) -
                  (statusOrder[b.currentStatus] ?? 3)
                );
              });

              return orderedTasks.map((task) => (
                <div
                  className="grid-task-row-box"
                  onClick={() => {
                    setSelectedApprovedTask(task);
                    setShowSelectedTaskWindow(true);
                    setShowApprovedTaskGrid(false);
                  }}
                  key={task._id}
                >
                  <div className="cmpy-id-status">
                    <div className="cmpy-task-id">
                      <h5>TaskId: </h5>
                      <p>#{task.taskId}</p>
                    </div>
                    <div
                      className="status-card-text"
                      style={getStatusClass(task.currentStatus)}
                    >
                      {task.currentStatus}
                    </div>
                  </div>
                  <div className="cmpy-task-title">
                    <h5>Title: </h5>
                    <p className="overflow-control">{task.title}</p>
                  </div>
                  <div className="cmpy-task-review-date">
                    <h5>Review Date: </h5>
                    <p>
                      {new Date(task.submissionForReview).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="cmpy-task-review-date">
                    <h5>Target Date: </h5>
                    <p>
                      {new Date(task.targetPostingDate).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="total-days">
                    <div className="submission-days">
                      <img src={active} alt="" />
                      Submission:{" "}
                      <p>{getDaysDifference(task.submissionForReview)}</p>
                    </div>
                    <div className="target-days">
                      <img src={targetactive} alt="" />
                      Target: <p>{getDaysDifference(task.targetPostingDate)}</p>
                    </div>
                  </div>
                  <div className="cmpy-task-view-btn-container">
                    <div className="cmpy-task-view-btn">View</div>
                  </div>
                </div>
              ));
            })}
          </div>
        )}

        {showSelectedTaskWindow && selectedApprovedTask && (
          <div className="admin-show-task-status-container">
            <div className="close-button-row">
              <img
                onClick={() => {
                  setShowSelectedTaskWindow(false);
                  setShowApprovedTaskGrid(true);
                }}
                width="48"
                height="48"
                src="https://img.icons8.com/fluency/48/delete-sign.png"
                alt="delete-sign"
                className="status-cross-symbol"
              />
            </div>

            <div className="status-top-floor">
              <div className="status-top-floor-row-1">
                <div className="status-col-1">
                  <div className="status-row rm-padding">
                    <div className="status-task-id">
                      <div className="task-id">Task ID</div>
                      <div className="task-id-number">
                        #{selectedApprovedTask.taskId}
                      </div>
                    </div>
                    <div
                      className="task-current-status"
                      style={getStatusClass(selectedApprovedTask.currentStatus)}
                    >
                      {selectedApprovedTask.currentStatus}
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Task Title</div>
                      <div className="task-title-name-status task-h">
                        {selectedApprovedTask.title}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Tagline or Slogan</div>
                      <div className="task-title-name-status task-h">
                        {selectedApprovedTask.tagline}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Purpose/Objective</div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.taskpurpose}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">Main Headline</div>
                      <div className="task-title-name-status task-h">
                        {selectedApprovedTask.headline}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Key Offer or Message
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.offerormessage}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Call to Action (CTA)
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.calltoaction}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Branding Guidelines
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.guidlines}
                      </div>
                    </div>
                    <div className="status-task-title">
                      <div className="task-title-status">
                        Additional Information
                      </div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.additionalinfo}
                      </div>
                    </div>
                    <div className="status-task-des">
                      <div className="task-title-status">Task Description</div>
                      <div className="task-title-name-status">
                        {selectedApprovedTask.description}
                      </div>
                    </div>
                    <div className="for-date-row">
                      <div className="status-task-dates">
                        <label className="task-title-status">Target Date</label>
                        <div className="status-target-date">
                          <input
                            type="date"
                            name="targetPostingDate"
                            value={formatDateForDisplay(
                              selectedApprovedTask.targetPostingDate
                            )}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="status-task-dates">
                        <label className="task-title-status">
                          Deadline Date
                        </label>
                        <div className="status-deadline-date">
                          <input
                            type="date"
                            name="submissionForReview"
                            value={formatDateForDisplay(
                              selectedApprovedTask.submissionForReview
                            )}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="platform-row-response">
                      <label className="new-task-date-label">
                        Selected Platforms has to Post:
                      </label>
                      <div className="social-checkbox">
                        {selectedApprovedTask.platform_x && (
                          <img src={x} className="checkbox__textwrapper" />
                        )}
                        {selectedApprovedTask.platform_fb && (
                          <img src={fb} className="checkbox__textwrapper" />
                        )}
                        {selectedApprovedTask.platform_insta && (
                          <img src={insta} className="checkbox__textwrapper" />
                        )}
                        {selectedApprovedTask.platform_li && (
                          <img src={li} className="checkbox__textwrapper" />
                        )}
                      </div>
                    </div>
                    {selectedApprovedTask.referenceImage && (
                      <div className="info-group-img">
                        <label className="task-title-status">
                          Reference Image
                        </label>
                        <a
                          href={selectedApprovedTask.referenceImage}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={selectedApprovedTask.referenceImage}
                            alt="Brand Relate Image 6"
                            className="profile-logo"
                          />
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                {selectedApprovedTask.currentStatus === "Roll Back" && (
                  <>
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="past-rollback">
                        <h3>Rollbac Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                {feedback.doneTaskImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.doneTaskImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        Admin Given Image
                                        <img
                                          src={feedback.doneTaskImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {feedback.clientSuggestImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.clientSuggestImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        User Suggest Image*
                                        <img
                                          src={feedback.clientSuggestImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {((feedback?.feedback ?? '').toString().trim().length > 0) && (
                                  <div className="feed-index">
                                    <div className="feedback-number">
                                      {index + 1})
                                    </div>
                                    <div className="feedback-text">
                                      {formatFeedbackText(feedback.feedback, `total-rollback-feedback-${index}`)}
                                    </div>
                                  </div>
                                )}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    <div className="admin-upload-image">
                      <label htmlFor="referenceimage">Upload Task Image:</label>
                      <input
                        type="file"
                        name="adminuploadtaskimage"
                        className="img-input admin-input"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setSelectedFile(file);
                          if (file) {
                            const preview = URL.createObjectURL(file);
                            setPreviewUrl(preview);
                          }
                        }}
                      />
                      <button
                        className="button-uploade"
                        disabled={!selectedFile || isUploading}
                        onClick={async () => {
                          if (!selectedApprovedTask || !selectedFile) return;

                          const formData = new FormData();
                          formData.append("image", selectedFile);

                          try {
                            setIsUploading(true);
                            const token = localStorage.getItem("token");

                            const response = await axios.post(
                              `${process.env.REACT_APP_API_URL}/admin/upload-task-image/${selectedApprovedTask._id}`,
                              formData,
                              {
                                headers: {
                                  "Content-Type": "multipart/form-data",
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            );

                            if (response.status === 200) {
                              toast.success(
                                "Task image uploaded successfully",
                                {
                                  autoClose: 500,
                                }
                              );
                              setShowTaskpreview(true);
                              setSelectedRolledBackTask((prev) => ({
                                ...prev,
                                referenceImage: response.data.task.image,
                              }));
                              setSelectedFile(null);
                            } else {
                              setShowTaskpreview(false);
                              toast.error("Image upload failed");
                            }
                          } catch (err) {
                            toast.error(
                              "Error uploading image: " + err.message
                            );
                          } finally {
                            setIsUploading(false);
                          }
                        }}
                      >
                        
                        
                        <span className="text" style={{ pointerEvents: 'none', userSelect: 'none' }}>
                          {isUploading ? "Uploading..." : "Upload"}
                        </span>
                      </button>
                    </div>
                    <div className="status-col-2">
                      {previewUrl && (
                        <img
                          src={previewUrl}
                          className="yet-task-preview-img"
                          alt="Task Preview"
                        />
                      )}
                    </div>
                  </>
                )}

                {selectedApprovedTask.currentStatus === "Approved" && (
                  <>
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                {feedback.doneTaskImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.doneTaskImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        Admin Given Image
                                        <img
                                          src={feedback.doneTaskImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {feedback.clientSuggestImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.clientSuggestImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        User Suggest Image*
                                        <img
                                          src={feedback.clientSuggestImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {((feedback?.feedback ?? '').toString().trim().length > 0) && (
                                  <div className="feed-index">
                                    <div className="feedback-number">
                                      {index + 1})
                                    </div>
                                    <div className="feedback-text">
                                      {formatFeedbackText(feedback.feedback, `total-approved-feedback-${index}`)}
                                    </div>
                                  </div>
                                )}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    <div className="task-preview-img-container">
                      <div className="status-title-preview">
                        Approved Task Image
                      </div>
                      <img
                        src={selectedApprovedTask.doneTaskImage}
                        className="yet-task-preview-img admin-img-btm"
                        alt="Task Preview"
                      />
                    </div>
                  </>
                )}

                {selectedApprovedTask.currentStatus === "Pending" && (
                  <>
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="admin-past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                <div className="feed-index">
                                  <div className="feedback-number">
                                    {index + 1})
                                  </div>
                                  <div className="feedback-text">
                                    {formatFeedbackText(feedback.feedback, `total-pending-feedback-${index}`)}
                                  </div>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                        <div className="task-preview-img-container">
                          <img
                            src={selectedApprovedTask.doneTaskImage}
                            className="yet-task-preview-img admin-img-btm"
                            alt="Task Preview"
                          />
                        </div>
                      </div>
                    )}
                    {selectedApprovedTask.doneTaskImage && (
                      <div className="task-preview-img-container">
                        <div className="status-title-preview">
                          Last Admin Uploaded Image
                        </div>
                        <img
                          src={selectedApprovedTask.doneTaskImage}
                          className="yet-task-preview-img admin-img-btm"
                          alt="Task Preview"
                        />
                      </div>
                    )}
                    <div className="admin-upload-image">
                      <label htmlFor="referenceimage">Upload Task Image:</label>
                      <input
                        type="file"
                        name="adminuploadtaskimage"
                        className="img-input admin-input"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setSelectedFile(file);
                          if (file) {
                            const preview = URL.createObjectURL(file);
                            setPreviewUrl(preview);
                          }
                        }}
                      />
                      <button
                        className="button-uploade"
                        disabled={!selectedFile || isUploading}
                        onClick={async () => {
                          if (!selectedApprovedTask || !selectedFile) return;

                          const formData = new FormData();
                          formData.append("image", selectedFile);

                          try {
                            setIsUploading(true);
                            const token = localStorage.getItem("token");

                            const response = await axios.post(
                              `${process.env.REACT_APP_API_URL}/admin/upload-task-image/${selectedApprovedTask._id}`,
                              formData,
                              {
                                headers: {
                                  "Content-Type": "multipart/form-data",
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            );

                            if (response.status === 200) {
                              toast.success(
                                "Task image uploaded successfully",
                                {
                                  autoClose: 500,
                                }
                              );
                              setShowTaskpreview(true);
                              setSelectedRolledBackTask((prev) => ({
                                ...prev,
                                referenceImage: response.data.task.image,
                              }));
                              setSelectedFile(null);
                            } else {
                              setShowTaskpreview(false);
                              toast.error("Image upload failed");
                            }
                          } catch (err) {
                            toast.error(
                              "Error uploading image: " + err.message
                            );
                          } finally {
                            setIsUploading(false);
                          }
                        }}
                      >
                      
                        <span className="text" style={{ pointerEvents: 'none', userSelect: 'none' }}>
                          {isUploading ? "Uploading..." : "Upload"}
                        </span>
                      </button>
                    </div>
                    <div className="status-col-2">
                      {previewUrl && (
                        <img
                          src={previewUrl}
                          className="yet-task-preview-img"
                          alt="Task Preview"
                        />
                      )}
                    </div>
                  </>
                )}

                {selectedApprovedTask.currentStatus === "Posted" && (
                  <>
                    {" "}
                    {selectedApprovedTask.rollbackFeedback.length > 0 && (
                      <div className="past-rollback">
                        <h3>Rollback Feedback</h3>
                        <ul>
                          {selectedApprovedTask.rollbackFeedback.map(
                            (feedback, index) => (
                              <li key={index}>
                                {feedback.doneTaskImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.doneTaskImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        Admin Given Image
                                        <img
                                          src={feedback.doneTaskImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {feedback.clientSuggestImage && (
                                  <div className="info-group-img">
                                    <a
                                      href={feedback.clientSuggestImage}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <label
                                        htmlFor=""
                                        className="adim-roll-row-label"
                                      >
                                        User Suggest Image*
                                        <img
                                          src={feedback.clientSuggestImage}
                                          alt="Brand Relate Image 6"
                                          className="profile-logo"
                                        />
                                      </label>
                                    </a>
                                  </div>
                                )}
                                {((feedback?.feedback ?? '').toString().trim().length > 0) && (
                                  <div className="feed-index">
                                    <div className="feedback-number">
                                      {index + 1})
                                    </div>
                                    <div className="feedback-text">
                                      {formatFeedbackText(feedback.feedback, `total-posted-feedback-${index}`)}
                                    </div>
                                  </div>
                                )}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    <div className="status-col-2">
                      {selectedApprovedTask.doneTaskImage && (
                        <div className="task-preview-img-container">
                          <div className="status-title-preview">
                            Posted Image
                          </div>
                          <img
                            src={selectedApprovedTask.doneTaskImage}
                            className="yet-task-preview-img admin-img-btm"
                            alt="Check Code"
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={true}
        transition={Zoom}
      />
    </>
  );
}
